var map = {
	"./10C.png": 145,
	"./10D.png": 1662,
	"./10H.png": 8114,
	"./10S.png": 561,
	"./2C.png": 3270,
	"./2D.png": 5689,
	"./2H.png": 4133,
	"./2S.png": 7894,
	"./3C.png": 5561,
	"./3D.png": 5478,
	"./3H.png": 1674,
	"./3S.png": 3273,
	"./4C.png": 5220,
	"./4D.png": 5435,
	"./4H.png": 8199,
	"./4S.png": 596,
	"./5C.png": 3391,
	"./5D.png": 7520,
	"./5H.png": 2620,
	"./5S.png": 1359,
	"./6C.png": 6930,
	"./6D.png": 6909,
	"./6H.png": 3921,
	"./6S.png": 6850,
	"./7C.png": 7381,
	"./7D.png": 506,
	"./7H.png": 5894,
	"./7S.png": 7989,
	"./8C.png": 4176,
	"./8D.png": 5503,
	"./8H.png": 4867,
	"./8S.png": 1664,
	"./9C.png": 3595,
	"./9D.png": 3684,
	"./9H.png": 3992,
	"./9S.png": 8523,
	"./AC.png": 4131,
	"./AD.png": 3964,
	"./AH.png": 5168,
	"./AS.png": 4579,
	"./JC.png": 7918,
	"./JD.png": 6401,
	"./JH.png": 6093,
	"./JS.png": 78,
	"./KC.png": 4401,
	"./KD.png": 7662,
	"./KH.png": 2562,
	"./KS.png": 3985,
	"./QC.png": 1219,
	"./QD.png": 3820,
	"./QH.png": 1392,
	"./QS.png": 147,
	"./back_of_card.png": 5375,
	"./blank_card.png": 3708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1760;